import { render, staticRenderFns } from "./privateCommon.vue?vue&type=template&id=3fac265d"
import script from "./privateCommon.vue?vue&type=script&lang=js"
export * from "./privateCommon.vue?vue&type=script&lang=js"
import style0 from "./privateCommon.vue?vue&type=style&index=0&id=3fac265d&prod&lang=css"
import style1 from "./privateCommon.vue?vue&type=style&index=1&id=3fac265d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports